import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { ServiceNotification } from 'Pages/admin'

export type ServiceNotificationsState = {
	list: ResponseCatalog<ServiceNotification>
	item: ServiceNotification | null
	requestParams: RequestParams
	isLoading: boolean
	activeList: ResponseCatalog<ServiceNotification>
}

export const initialState: ServiceNotificationsState = {
	list: new ResponseCatalog<ServiceNotification>(),
	item: null,
	requestParams: new RequestParams(),
	isLoading: false,
	activeList: new ResponseCatalog<ServiceNotification>(),
}

export namespace ServiceNotificationsNS {
	export type GetList = PayloadAction<{
		params?: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetList = PayloadAction<ResponseCatalog<ServiceNotification>>
	export type GetNotification = PayloadAction<number>
	export type SetNotification = PayloadAction<ServiceNotification>
	export type CreateNotification = PayloadAction<ServiceNotification>
	export type UpdateNotification = PayloadAction<{ data: ServiceNotification; isGrid?: boolean }>
	export type DeleteNotification = PayloadAction<number>
	export type ReadNotification = PayloadAction<{ id: number; isComplete: boolean }>
	export type SetRequestParams = PayloadAction<RequestParams>
	export type SetIsLoading = PayloadAction<boolean>
	export type GetActiveList = PayloadAction
	export type SetActiveList = PayloadAction<ResponseCatalog<ServiceNotification>>
}

export const serviceNotificationsSlice = createSlice({
	name: 'serviceNotifications',
	initialState,
	reducers: {
		getList: (state, action: ServiceNotificationsNS.GetList) => {},
		setList: (state, action: ServiceNotificationsNS.SetList) => {
			state.list = action.payload
		},
		clearList: (state) => {
			state.list = new ResponseCatalog<ServiceNotification>()
			state.requestParams = new RequestParams()
		},
		getNotification: (state, action: ServiceNotificationsNS.GetNotification) => {},
		setNotification: (state, action: ServiceNotificationsNS.SetNotification) => {
			state.item = action.payload
		},
		createNotification: (state, action: ServiceNotificationsNS.CreateNotification) => {},
		updateNotification: (state, action: ServiceNotificationsNS.UpdateNotification) => {},
		readNotification: (state, action: ServiceNotificationsNS.ReadNotification) => {
			state.activeList.entries = state.activeList.entries.filter(
				(item) => item.id !== action.payload.id
			)
		},
		deleteNotification: (state, action: ServiceNotificationsNS.DeleteNotification) => {},
		clearNotification: (state) => {
			state.item = null
		},

		setRequestParams: (state, action: ServiceNotificationsNS.SetRequestParams) => {
			state.requestParams = action.payload
		},
		setIsLoading: (state, action: ServiceNotificationsNS.SetIsLoading) => {
			state.isLoading = action.payload
		},
		getActiveList: (state, action: ServiceNotificationsNS.GetActiveList) => {},
		setActiveList: (state, action: ServiceNotificationsNS.SetActiveList) => {
			state.activeList = action.payload
		},
	},
})
